import { useGetQueryLevelsQuery } from "~/graphql/supergraphHooks";
import { FALLBACK_QUERY_ROLLUP_LEVEL_OPTIONS } from "./fallbackCatalogue";
import { getCatalogueValues } from "./levelStack";
import type { QueryRollupLevelOption } from "./types";

type UseQueryRollupLevelsResult = {
  options: readonly QueryRollupLevelOption[];
  values: readonly string[];
  isLoading: boolean;
  error?: Error;
};

/**
 * Source the Query Builder "Levels" dropdown from the data-service
 * `finpubQueryLevels` curated catalogue. An explicit `override` always wins
 * (used by tests and callers supplying their own options); otherwise, while the
 * query is in flight — or if it fails or returns nothing — fall back to the
 * interim catalogue so the dropdown is never empty.
 */
export const useQueryRollupLevels = (
  override?: ReadonlyArray<QueryRollupLevelOption>,
): UseQueryRollupLevelsResult => {
  const { data, loading, error } = useGetQueryLevelsQuery({ skip: override !== undefined });

  const fetched = data?.finpubQueryLevels ?? [];
  const options =
    override ??
    (fetched.length > 0
      ? fetched.map(({ value, label }) => ({ value, label }))
      : FALLBACK_QUERY_ROLLUP_LEVEL_OPTIONS);

  return {
    options,
    values: getCatalogueValues(options),
    isLoading: override === undefined && loading,
    error: error ?? undefined,
  };
};
